import type { ColumnMap } from "@/react/prop-types";
import { DateFilter } from "../data-table/custom-filters/date-filter";
import MultiSelectPillFilter from "../data-table/custom-filters/multiselect-pill-filter";
import { NumericValueFilter } from "../data-table/custom-filters/numeric-value-filter";
import { StatusFilter } from "../data-table/custom-filters/status-filter";
import { MultiSelectFilterRenderer } from "@procore/data-table";

export const filterRendererMap: ColumnMap = {
   tag_instances: MultiSelectPillFilter,
   status: StatusFilter,
   bid_rate: NumericValueFilter,
   percent_complete: NumericValueFilter,
   start_date: DateFilter,
   est_end_date: DateFilter,
   hourly_wage: NumericValueFilter,
   permission: MultiSelectFilterRenderer,
};
